/** Maximum number of members per aidol group */
export const MAX_MEMBERS = 25;
